import Logger from '../logger';

const sendGoogleAnalyticsEvent = (eventName, eventArgs) => {
    if (!window.dataLayer) {
        Logger.error('[GTM] no dataLayer object');
        return;
    }

    Logger.log(`[GTM] init with eventName=${eventName}, eventArgs=${JSON.stringify(eventArgs)}`);

    if (!eventName) {
        Logger.error('[GTM] no event name');
        return;
    }

    const GTMEvent = {
        event: eventName,
        ...(eventArgs && {
            ...eventArgs
        })
    };
    Logger.log(`[GTM] sending GA Event: ${JSON.stringify(GTMEvent)}`);

    window.dataLayer.push(GTMEvent);
};

export { sendGoogleAnalyticsEvent };
